'use client'
import Modal from '@/components/modal'
import { TrackCookieSection, TrackExposure } from 'modules/analysis'
import { Cookie, CookieList, CookieSettingTitle } from 'modules/constant'
import { Switch } from 'modules/components'
import { useState } from 'react'

export function CookieDetailModal(props: { onClose: (val?: Cookie[]) => void; defaultValue: Cookie[] }) {
  const { onClose, defaultValue } = props

  const [checked, setChecked] = useState(defaultValue)

  return (
    <Modal
      onClose={() => {
        onClose()
      }}
      className="h-[80vh] min-w-[50vw] overflow-hidden"
    >
      <TrackExposure config={{ sectionName: TrackCookieSection.Setting }}>
        <div className="flex-y h-full px-5 pb-5 pt-1">
          <span className="mb-5 text-4xl font-bold">{CookieSettingTitle}</span>
          <div className="flex-y-auto overflow-y-auto outline-none">
            {CookieList.map((item) => (
              <div className="gap-x-30 mb-10 flex" key={item.value}>
                <div>
                  <p className="mb-4 text-2xl font-bold">{item.title}</p>
                  <p className="text-base">{item.description}</p>
                </div>
                <Switch
                  disabled={item.disabled}
                  className="mr-3 shrink-0 self-center"
                  value={checked.includes(item.value) || !!item.defaultChecked}
                  onChange={(val) => {
                    if (val) {
                      setChecked([...checked, item.value])
                    } else {
                      setChecked(checked.filter((cookie) => cookie !== item.value))
                    }
                  }}
                />
              </div>
            ))}
          </div>
          <TrackExposure
            config={{ sectionName: TrackCookieSection.Save }}
            withClick={{ attr: { optionName: checked } }}
          >
            <button
              onClick={() => {
                onClose(checked)
              }}
              className="primary-button mt-6 self-center text-lg font-bold"
            >
              SAVE
            </button>
          </TrackExposure>
        </div>
      </TrackExposure>
    </Modal>
  )
}
